import { UsaPage } from '@pages/Usa/UsaPage';
import { useReactData } from '@/hooks/useReactData';

export default function UsaPageContainer() {
  const data = useReactData();
  if (!data || !data.fase) return 'Inactive...';

  return (
    <>
      {data && (
        <UsaPage
          tourDates={data.tourDates}
          fase={data.fase}
          csrf_token={data.csrf_token}
        />
      )}
    </>
  );
}
